import { formatDate } from '../../../utils';

export const content = {
  isNullError: 'Eingabe erforderlich',
  isBeforeMinDateError: (minDate: Date | undefined) => `Das Datum muss nach dem ${formatDate(minDate)} liegen`,
  isForbiddenWeekendDateError: 'Planung enthält ein Wochenende',
} as const;
